import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import MetacriticIcon from '@/pages/opinion/assets/svg/channel/metacritic.svg';
import SteamIcon from '@/pages/opinion/assets/svg/channel/steam.svg';
import Xbox from '@/pages/opinion/assets/svg/channel/xbox.svg';
import { initialUpperCase } from '../utils';

const map: any = {
  positive: <SvgIcon type="good-icon" className="dbo-select-rating-icon" />,
  negative: <SvgIcon type="no-good-icon" className="dbo-select-rating-icon" />,
  mixed: 'Mixed',
};

export function buttonItemRender(start: number | string, formatMessage: any) {
  if (typeof start !== 'number') {
    if (typeof map[start] === 'string') {
      return <span className="dbo-select-rating-text">{formatMessage({ id: map[start] })}</span>;
    }
    return map[start];
  }
  return <>{start}</>;
}

export const pcRantingOptions = (formatMessage: any) => {
  return [
    {
      value: 'positive',
      text: (
        <div className="dbo-rating-select">
          <div className="dbo-rating-select-title">
            {formatMessage({ id: 'Positive' })}
          </div>
          <div className="dbo-rating-select-flex">
            <img src={SteamIcon} className="flex-img" />
            {formatMessage({ id: 'Recommended' })}
            <SvgIcon type="good-icon" className="flex-icon" />
          </div>
          <div className="dbo-rating-select-flex">
            <img src={MetacriticIcon} className="flex-img" />
            {formatMessage({ id: 'Metascore' })}
            <span className="flex-num-green">71-100</span>
            {formatMessage({ id: 'Userscore' })}
            <span className="flex-num-green">8-10</span>
          </div>
          <div className="dbo-rating-select-flex">
            <img src={Xbox} className="flex-img" />
            <div className="dbo-rating-select-box">
              {[1, 2, 3, 4, 5].map((e, i) => {
                return (
                  <SvgIcon key={e} type="star-action" className="star-icon" />
                );
              })}
              <span className="star-text">5</span>
            </div>
            <div className="dbo-rating-select-box">
              {[1, 2, 3, 4].map((e, i) => {
                return (
                  <SvgIcon key={e} type="star-action" className="star-icon" />
                );
              })}
              <span className="star-text">4</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 'negative',
      text: (
        <div className="dbo-rating-select">
          <div className="dbo-rating-select-title">
            {formatMessage({ id: 'Negative' })}
          </div>
          <div className="dbo-rating-select-flex">
            <img src={SteamIcon} className="flex-img" />
            {formatMessage({ id: 'Not Recommended' })}
            <SvgIcon type="no-good-icon" className="flex-icon" />
          </div>
          <div className="dbo-rating-select-flex">
            <img src={MetacriticIcon} className="flex-img" />
            {formatMessage({ id: 'Metascore' })}
            <span className="flex-num-red">0-40</span>
            {formatMessage({ id: 'Userscore' })}
            <span className="flex-num-red">1-4</span>
          </div>
          <div className="dbo-rating-select-flex">
            <img src={Xbox} className="flex-img" />
            <div className="dbo-rating-select-box">
              {[1, 2].map((e, i) => {
                return (
                  <SvgIcon key={e} type="star-action" className="star-icon" />
                );
              })}
              <span className="star-text">2</span>
            </div>
            <div className="dbo-rating-select-box">
              {[1].map((e, i) => {
                return (
                  <SvgIcon key={e} type="star-action" className="star-icon" />
                );
              })}
              <span className="star-text">1</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 'mixed',
      text: (
        <div className="dbo-rating-select">
          <div className="dbo-rating-select-title">
            {formatMessage({ id: 'Mixed' })}
          </div>
          <div className="dbo-rating-select-flex">
            <img src={MetacriticIcon} className="flex-img" />
            {formatMessage({ id: 'Metascore' })}
            <span className="flex-num-grey">40-70</span>
            {formatMessage({ id: 'Userscore' })}
            <span className="flex-num-grey">5-7</span>
          </div>
          <div className="dbo-rating-select-flex">
            <img src={Xbox} className="flex-img" />
            <div className="dbo-rating-select-box">
              {[1, 2, 3].map((e, i) => {
                return (
                  <SvgIcon key={e} type="star-action" className="star-icon" />
                );
              })}
              <span className="star-text">3</span>
            </div>
          </div>
        </div>
      ),
    },
  ];
};

function mobileOptions(start: number) {
  if (typeof start !== 'number') {
    return initialUpperCase(start);
  }
  let ele: Array<JSX.Element> = [];
  for (let index = 0; index < start; index++) {
    ele.push(
      <SvgIcon
        key={'start1' + index}
        type="star-action"
        className="dbo-select-star-icon"
      />,
    );
  }
  if (5 - start > 0) {
    for (let index = 0; index < 5 - start; index++) {
      ele.push(
        <SvgIcon
          key={'start2' + index}
          type="star-action"
          className="dbo-select-star-icon dbo-select-star-icon--grey"
        />,
      );
    }
  }
  ele.push(
    <span key={start} className="dbo-select-star-text">
      {start}
    </span>,
  );
  return <div className="dbo-select-flex">{ele}</div>;
}

export const mobileRantingOptions = [5, 4, 3, 2, 1].map((item) => ({
  text: mobileOptions(item),
  value: String(item),
}));
